import React, { useState, useEffect } from 'react';
import { Button, Modal, Alert } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FaPencilAlt } from "react-icons/fa";
import axios from 'axios';

function EnoTable({ caseId }) {

  const inputStyle = {
    border: '2px solid #ccc',
    borderRadius: '4px',
    padding: '8px',
    width: '100px',
    marginBottom: '10px',
  };

  const labelStyle = {
    marginLeft: '10px',
  };

  const [show, setShow] = useState(false);
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);

  const [enclosures, setEnclosures] = useState({
    alginateMandibularImpression: 0,
    alginateMaxillaryImpression: 0,
    approvedProvisionalModel: 0,
    articulator: 0,
    bisqueCrowns: 0,
    biteBlocks: 0,
    biteFork: 0,
    biteRegistration: 0,
    dentureTeeth: 0,
    facebow: 0,
    implantParts: 0,
    mandibularImpression: 0,
    mandibularStudyModel: 0,
    maxillaryImpression: 0,
    maxillaryStudyModel: 0,
    metalFramework: 0,
    nameApprovedProvisionalModel: 0,
    oldCrown: 0,
    opposingModel: 0,
    patientDenturePartial: 0,
    photographs: 0,
    shadeTab: 0,
    tripleTrayImpression: 0,
    waxBiteRegistration: 0,
    waxSetup: 0,
    workingModel: 0,
  });

  useEffect(() => {
    if (show && caseId) {
      const fetchEnclosures = async () => {
        try {
          const response = await axios.get(
            `https://hms.backend.hiragroupcloud.com/api/cases/${caseId}/enclosures`
          );

          if (response.data?.data?.enclosures) {
            setEnclosures(response.data.data.enclosures);
          }
        } catch (error) {
          console.error(
            'Error fetching enclosures:',
            error
          );
        }
      };

      fetchEnclosures();
    }
  }, [show, caseId]);

  const handleClose = () => {
    setShow(false);
    setShowSuccessAlert(false);
  };

  const handleShow = () => setShow(true);

  const handleInputChange = (field, value) => {
    setEnclosures(prev => ({
      ...prev,
      [field]: Number(value) || 0
    }));
  };

  const handleSave = async () => {
    try {
      await axios.put(
        `https://hms.backend.hiragroupcloud.com/api/cases/${caseId}/enclosures`,
        enclosures
      );

      setShowSuccessAlert(true);

      setTimeout(() => {
        setShowSuccessAlert(false);
      }, 3000);

    } catch (error) {
      console.error(
        'Error saving enclosures:',
        error
      );

      alert(
        'Failed to save enclosures. Please try again.'
      );
    }
  };

  const modalBodyStyle = {
    height: '500px',
    overflowY: 'auto',
    position: 'relative',
    overflowX: 'hidden',
  };

  return (
    <div className="App">

      {/* =========================
          RESPONSIVE MOBILE CSS
          ========================= */}
      <style>
        {`

          /* --------------------------------
             TABLET / SMALL SCREEN
             -------------------------------- */
          @media (max-width: 767px) {

            /* Edit pencil button - remove background on mobile */
            .edit-enclosures-btn {
              background-color: transparent !important;
              border-color: transparent !important;
              box-shadow: none !important;
              padding: 4px 6px !important;
            }

            .edit-enclosures-btn svg {
              color: #004aad !important;
              fill: #004aad !important;
            }

            .edit-enclosures-btn:hover,
            .edit-enclosures-btn:focus,
            .edit-enclosures-btn:active {
              background-color: transparent !important;
              border-color: transparent !important;
              box-shadow: none !important;
            }

            .enclosures-responsive-modal {
              width: 100%;
              max-width: none;
              margin: 0;
              padding-left: 5px;
              padding-right: 5px;
            }

            .enclosures-responsive-modal .modal-content {
              width: 100%;
              max-width: 100%;
              margin: 0 auto;
              overflow: hidden;
              border-radius: 7px;
            }

            /* Header */
            .enclosures-responsive-modal .modal-header {
              padding: 6px 9px;
              min-height: auto;
            }

            .enclosures-responsive-modal .modal-title {
              font-size: 13px !important;
              line-height: 1.1;
              max-width: calc(100% - 30px);
              white-space: normal;
              word-break: break-word;
            }

            /* Close X button */
            .enclosures-responsive-modal .btn-close {
              font-size: 10px;
              padding: 5px;
            }

            /* Body */
            .enclosures-responsive-modal .modal-body {
              height: auto !important;
              max-height: calc(100vh - 105px);
              overflow-y: auto !important;
              overflow-x: hidden !important;
              padding: 8px !important;
            }

            /* Each input + label row */
            .enclosures-responsive-modal .enclosure-row {
              display: flex;
              align-items: center;
              width: 100%;
              max-width: 100%;
              margin-bottom: 5px;
              gap: 5px;
              box-sizing: border-box;
            }

            /* Smaller input */
            .enclosures-responsive-modal .enclosure-input {
              width: 52px !important;
              min-width: 52px;
              max-width: 52px;

              height: 28px !important;

              margin-bottom: 0 !important;

              padding: 3px 5px !important;

              font-size: 11px !important;

              border-width: 1px !important;

              border-radius: 3px !important;

              box-sizing: border-box;
            }

            /* Smaller labels */
            .enclosures-responsive-modal .enclosure-label {
              margin-left: 0 !important;

              font-size: 10px !important;

              line-height: 1.15;

              white-space: normal;

              word-break: break-word;

              overflow-wrap: anywhere;

              flex: 1;

              min-width: 0;
            }

            /* Success Alert */
            .enclosures-responsive-modal .alert {
              font-size: 10px !important;

              padding: 5px 7px !important;

              margin-bottom: 7px;

              line-height: 1.2;
            }

            /* Footer */
            .enclosures-responsive-modal .modal-footer {
              padding: 5px 8px;

              gap: 4px;

              flex-wrap: wrap;
            }

            .enclosures-responsive-modal .modal-footer .btn {
              font-size: 10px !important;

              padding: 4px 9px !important;

              border-radius: 3px;
            }
          }


          /* --------------------------------
             VERY SMALL MOBILE SCREEN
             -------------------------------- */
          @media (max-width: 380px) {

            .edit-enclosures-btn {
              padding: 2px 4px !important;
            }

            .enclosures-responsive-modal {
              padding-left: 3px;
              padding-right: 3px;
            }

            .enclosures-responsive-modal .modal-content {
              border-radius: 5px;
            }

            /* Header even smaller */
            .enclosures-responsive-modal .modal-header {
              padding: 5px 7px;
            }

            .enclosures-responsive-modal .modal-title {
              font-size: 11px !important;
            }

            .enclosures-responsive-modal .btn-close {
              font-size: 8px;
              padding: 4px;
            }

            /* Body even smaller */
            .enclosures-responsive-modal .modal-body {
              padding: 6px !important;

              max-height: calc(100vh - 90px);
            }

            /* Smaller rows */
            .enclosures-responsive-modal .enclosure-row {
              gap: 4px;

              margin-bottom: 3px;
            }

            /* Very small inputs */
            .enclosures-responsive-modal .enclosure-input {
              width: 45px !important;
              min-width: 45px;
              max-width: 45px;

              height: 24px !important;

              padding: 2px 4px !important;

              font-size: 9px !important;

              border-width: 1px !important;
            }

            /* Very small labels */
            .enclosures-responsive-modal .enclosure-label {
              font-size: 9px !important;

              line-height: 1.05;
            }

            /* Alert */
            .enclosures-responsive-modal .alert {
              font-size: 9px !important;

              padding: 4px 5px !important;

              margin-bottom: 5px;
            }

            /* Footer */
            .enclosures-responsive-modal .modal-footer {
              padding: 4px 6px;

              gap: 3px;
            }

            .enclosures-responsive-modal .modal-footer .btn {
              font-size: 9px !important;

              padding: 3px 7px !important;
            }
          }

        `}
      </style>

      {/* =========================
          EDIT BUTTON
          ========================= */}
      <Button
        className="edit-enclosures-btn"
        style={{
          backgroundColor: '#004aad',
          borderColor: '#004aad',
        }}
        onClick={handleShow}
      >
        <FaPencilAlt
          style={{ fontSize: '20px' }}
        />
      </Button>

      {/* =========================
          MODAL
          ========================= */}
      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        centered
        dialogClassName="enclosures-responsive-modal"
      >

        {/* HEADER */}
        <Modal.Header
          closeButton
          style={{
            backgroundColor: '#004aad',
            borderBottom: '2px solid #ccc'
          }}
        >
          <Modal.Title
            style={{
              color: 'white',
              textAlign: "left",
              display: 'inline-block'
            }}
          >
            Enclosures
          </Modal.Title>
        </Modal.Header>

        {/* BODY */}
        <Modal.Body style={modalBodyStyle}>

          {showSuccessAlert && (
            <Alert
              variant="success"
              onClose={() =>
                setShowSuccessAlert(false)
              }
              dismissible
            >
              Enclosures saved successfully!
            </Alert>
          )}

          {/* 1 */}
          <div className="enclosure-row">
            <input
              type="number"
              value={enclosures.alginateMandibularImpression}
              onChange={(e) =>
                handleInputChange(
                  'alginateMandibularImpression',
                  e.target.value
                )
              }
              className="enclosure-input"
              style={inputStyle}
            />
            <label className="enclosure-label">
              Alginate Mandibular Impression
            </label>
          </div>

          {/* 2 */}
          <div className="enclosure-row">
            <input
              type="number"
              value={enclosures.alginateMaxillaryImpression}
              onChange={(e) =>
                handleInputChange(
                  'alginateMaxillaryImpression',
                  e.target.value
                )
              }
              className="enclosure-input"
              style={inputStyle}
            />
            <label className="enclosure-label">
              Alginate Maxillary Impression
            </label>
          </div>

          {/* 3 */}
          <div className="enclosure-row">
            <input
              type="number"
              value={enclosures.approvedProvisionalModel}
              onChange={(e) =>
                handleInputChange(
                  'approvedProvisionalModel',
                  e.target.value
                )
              }
              className="enclosure-input"
              style={inputStyle}
            />
            <label className="enclosure-label">
              Approved Provisional Model
            </label>
          </div>

          {/* 4 */}
          <div className="enclosure-row">
            <input
              type="number"
              value={enclosures.articulator}
              onChange={(e) =>
                handleInputChange(
                  'articulator',
                  e.target.value
                )
              }
              className="enclosure-input"
              style={inputStyle}
            />
            <label className="enclosure-label">
              Articulator
            </label>
          </div>

          {/* 5 */}
          <div className="enclosure-row">
            <input
              type="number"
              value={enclosures.bisqueCrowns}
              onChange={(e) =>
                handleInputChange(
                  'bisqueCrowns',
                  e.target.value
                )
              }
              className="enclosure-input"
              style={inputStyle}
            />
            <label className="enclosure-label">
              Bisque Crowns
            </label>
          </div>

          {/* 6 */}
          <div className="enclosure-row">
            <input
              type="number"
              value={enclosures.biteBlocks}
              onChange={(e) =>
                handleInputChange(
                  'biteBlocks',
                  e.target.value
                )
              }
              className="enclosure-input"
              style={inputStyle}
            />
            <label className="enclosure-label">
              Bite Blocks
            </label>
          </div>

          {/* 7 */}
          <div className="enclosure-row">
            <input
              type="number"
              value={enclosures.biteFork}
              onChange={(e) =>
                handleInputChange(
                  'biteFork',
                  e.target.value
                )
              }
              className="enclosure-input"
              style={inputStyle}
            />
            <label className="enclosure-label">
              Bite Fork
            </label>
          </div>

          {/* 8 */}
          <div className="enclosure-row">
            <input
              type="number"
              value={enclosures.biteRegistration}
              onChange={(e) =>
                handleInputChange(
                  'biteRegistration',
                  e.target.value
                )
              }
              className="enclosure-input"
              style={inputStyle}
            />
            <label className="enclosure-label">
              Bite Registration
            </label>
          </div>

          {/* 9 */}
          <div className="enclosure-row">
            <input
              type="number"
              value={enclosures.dentureTeeth}
              onChange={(e) =>
                handleInputChange(
                  'dentureTeeth',
                  e.target.value
                )
              }
              className="enclosure-input"
              style={inputStyle}
            />
            <label className="enclosure-label">
              Denture Teeth
            </label>
          </div>

          {/* 10 */}
          <div className="enclosure-row">
            <input
              type="number"
              value={enclosures.facebow}
              onChange={(e) =>
                handleInputChange(
                  'facebow',
                  e.target.value
                )
              }
              className="enclosure-input"
              style={inputStyle}
            />
            <label className="enclosure-label">
              Facebow
            </label>
          </div>

          {/* 11 */}
          <div className="enclosure-row">
            <input
              type="number"
              value={enclosures.implantParts}
              onChange={(e) =>
                handleInputChange(
                  'implantParts',
                  e.target.value
                )
              }
              className="enclosure-input"
              style={inputStyle}
            />
            <label className="enclosure-label">
              Implant Parts
            </label>
          </div>

          {/* 12 */}
          <div className="enclosure-row">
            <input
              type="number"
              value={enclosures.mandibularImpression}
              onChange={(e) =>
                handleInputChange(
                  'mandibularImpression',
                  e.target.value
                )
              }
              className="enclosure-input"
              style={inputStyle}
            />
            <label className="enclosure-label">
              Mandibular Impression
            </label>
          </div>

          {/* 13 */}
          <div className="enclosure-row">
            <input
              type="number"
              value={enclosures.mandibularStudyModel}
              onChange={(e) =>
                handleInputChange(
                  'mandibularStudyModel',
                  e.target.value
                )
              }
              className="enclosure-input"
              style={inputStyle}
            />
            <label className="enclosure-label">
              Mandibular Study Model
            </label>
          </div>

          {/* 14 */}
          <div className="enclosure-row">
            <input
              type="number"
              value={enclosures.maxillaryImpression}
              onChange={(e) =>
                handleInputChange(
                  'maxillaryImpression',
                  e.target.value
                )
              }
              className="enclosure-input"
              style={inputStyle}
            />
            <label className="enclosure-label">
              Maxillary Impression
            </label>
          </div>

          {/* 15 */}
          <div className="enclosure-row">
            <input
              type="number"
              value={enclosures.maxillaryStudyModel}
              onChange={(e) =>
                handleInputChange(
                  'maxillaryStudyModel',
                  e.target.value
                )
              }
              className="enclosure-input"
              style={inputStyle}
            />
            <label className="enclosure-label">
              Maxillary Study Model
            </label>
          </div>

          {/* 16 */}
          <div className="enclosure-row">
            <input
              type="number"
              value={enclosures.metalFramework}
              onChange={(e) =>
                handleInputChange(
                  'metalFramework',
                  e.target.value
                )
              }
              className="enclosure-input"
              style={inputStyle}
            />
            <label className="enclosure-label">
              Metal Framework
            </label>
          </div>

          {/* 17 */}
          <div className="enclosure-row">
            <input
              type="number"
              value={enclosures.nameApprovedProvisionalModel}
              onChange={(e) =>
                handleInputChange(
                  'nameApprovedProvisionalModel',
                  e.target.value
                )
              }
              className="enclosure-input"
              style={inputStyle}
            />
            <label className="enclosure-label">
              Name Approved Provisional Model
            </label>
          </div>

          {/* 18 */}
          <div className="enclosure-row">
            <input
              type="number"
              value={enclosures.oldCrown}
              onChange={(e) =>
                handleInputChange(
                  'oldCrown',
                  e.target.value
                )
              }
              className="enclosure-input"
              style={inputStyle}
            />
            <label className="enclosure-label">
              Old Crown
            </label>
          </div>

          {/* 19 */}
          <div className="enclosure-row">
            <input
              type="number"
              value={enclosures.opposingModel}
              onChange={(e) =>
                handleInputChange(
                  'opposingModel',
                  e.target.value
                )
              }
              className="enclosure-input"
              style={inputStyle}
            />
            <label className="enclosure-label">
              Opposing Model
            </label>
          </div>

          {/* 20 */}
          <div className="enclosure-row">
            <input
              type="number"
              value={enclosures.patientDenturePartial}
              onChange={(e) =>
                handleInputChange(
                  'patientDenturePartial',
                  e.target.value
                )
              }
              className="enclosure-input"
              style={inputStyle}
            />
            <label className="enclosure-label">
              Patient Denture/Partial
            </label>
          </div>

          {/* 21 */}
          <div className="enclosure-row">
            <input
              type="number"
              value={enclosures.photographs}
              onChange={(e) =>
                handleInputChange(
                  'photographs',
                  e.target.value
                )
              }
              className="enclosure-input"
              style={inputStyle}
            />
            <label className="enclosure-label">
              Photographs
            </label>
          </div>

          {/* 22 */}
          <div className="enclosure-row">
            <input
              type="number"
              value={enclosures.shadeTab}
              onChange={(e) =>
                handleInputChange(
                  'shadeTab',
                  e.target.value
                )
              }
              className="enclosure-input"
              style={inputStyle}
            />
            <label className="enclosure-label">
              Shade Tab
            </label>
          </div>

          {/* 23 */}
          <div className="enclosure-row">
            <input
              type="number"
              value={enclosures.tripleTrayImpression}
              onChange={(e) =>
                handleInputChange(
                  'tripleTrayImpression',
                  e.target.value
                )
              }
              className="enclosure-input"
              style={inputStyle}
            />
            <label className="enclosure-label">
              Triple Tray Impression
            </label>
          </div>

          {/* 24 */}
          <div className="enclosure-row">
            <input
              type="number"
              value={enclosures.waxBiteRegistration}
              onChange={(e) =>
                handleInputChange(
                  'waxBiteRegistration',
                  e.target.value
                )
              }
              className="enclosure-input"
              style={inputStyle}
            />
            <label className="enclosure-label">
              Wax Bite Registration
            </label>
          </div>

          {/* 25 */}
          <div className="enclosure-row">
            <input
              type="number"
              value={enclosures.waxSetup}
              onChange={(e) =>
                handleInputChange(
                  'waxSetup',
                  e.target.value
                )
              }
              className="enclosure-input"
              style={inputStyle}
            />
            <label className="enclosure-label">
              Wax Setup
            </label>
          </div>

          {/* 26 */}
          <div className="enclosure-row">
            <input
              type="number"
              value={enclosures.workingModel}
              onChange={(e) =>
                handleInputChange(
                  'workingModel',
                  e.target.value
                )
              }
              className="enclosure-input"
              style={inputStyle}
            />
            <label className="enclosure-label">
              Working Model
            </label>
          </div>

        </Modal.Body>

        {/* FOOTER */}
        <Modal.Footer>

          <Button
            onClick={handleClose}
            style={{
              backgroundColor: '#004aad',
              borderColor: '#004aad',
            }}
          >
            Cancel
          </Button>

          <Button
            onClick={handleSave}
            style={{
              backgroundColor: '#004aad',
              borderColor: '#004aad',
            }}
          >
            Save
          </Button>

        </Modal.Footer>

      </Modal>
    </div>
  );
}

export default EnoTable;